<template>
    <div>
        <h2>Комментарий для администратора</h2>
        <ModelTextArea
            v-model="text"
            label="Напишите комментарий"
            :disabled="loading"
        ></ModelTextArea>
        <Button
            lass="btn_send"
            @click="send"
            :disabled="!canSend"
        >Отправить</Button>
    </div>
</template>

<script>
import Button from '../../UI/Button';
import ModelTextArea from '../../UI/models/ModelTextArea';
import {mapActions, mapState} from "vuex";

export default {
    name: 'ProposalCreateComment',
    components: {
        Button,
        ModelTextArea,
    },
    data: () => ({
        text: '',
        loading: false,
    }),
    props: {
        status: {
            type: Number,
        },
    },
    computed: {
        canSend() {
            return !this.loading && this.text.length > 0;
        },
    },
    methods: {
        ...mapActions('proposals', [
            'updateProposal',
        ]),
        async send() {
            this.loading = true;
            await this.updateProposal({ status: this.status, comment: this.text });
            this.text = '';
            this.loading = false;
        },
    },
};
</script>

<style lang="scss" scoped>
    @import '../../../styles/rem';

    .btn_send {
        width: rem(161);

        @include on-mobile {
            width: 100%;
        }
    }
</style>
